<app-navbar [complex]="true" [withServices]="true" [withBlog]="true"></app-navbar>
<main role="main">
  <div class="page-header section-dark main-background"></div>
  @defer (when homepageNotice()?.active) {
    <ngb-toast [header]="this.homepageNotice()?.title ?? ''" class="info start-50 translate-middle-x"
               [hidden]="!this.homepageNotice()?.active"
               [autohide]="false">
    <span class="description">
      {{ homepageNotice()?.details ?? '' }}
    </span>
    </ngb-toast>
  }
  <img class="booksy-widget clickable" ngSrc="assets/booksy-custom.svg" alt="Widżet Booksy" height="80" width="80"
       (click)="openBooksyDialog()" priority>
  @defer (when homepageNotice()?.active) {
    <app-toast-container></app-toast-container>
  }
  <app-about-me-section></app-about-me-section>
  <app-first-visit-section></app-first-visit-section>
  <app-services-section></app-services-section>
  <app-gallery-section></app-gallery-section>
  <app-reviews-section></app-reviews-section>
  <app-faq-section></app-faq-section>
  <app-email-message-section-wrapper>
    @defer (on viewport) {
      <app-email-message-section></app-email-message-section>
    } @placeholder (minimum 500ms) {
      <app-email-message-section-placeholder></app-email-message-section-placeholder>
    }
  </app-email-message-section-wrapper>
  <app-contact-section></app-contact-section>
</main>
<app-footer></app-footer>
